import Vue from 'vue'
import VueRouter from 'vue-router'

import DashboardIndex from '../views/Dashboard'

import Media from '../views/Media'
import MediaIndex from '../views/media/Index'

import FoodSearch from '../views/FoodSearch'
import FoodSearchIndex from '../views/food-search/Index'
import FoodSearchRequestsIndex from '../views/food-search/RequestsIndex'

import AdminIndex from '../views/Admin'
import AdminUsersIndex from '../views/admin/users/Index'
import AdminPermissionsIndex from '../views/admin/permissions/Index'

import Auth from '../views/Auth'
import AuthIndex from '../views/auth/Index'
//import AuthForgotPassword from '../views/auth/ForgotPassword'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: DashboardIndex,
    meta: { title: 'Dashboard' }
  },
  {
    path: '/media',
    component: Media,
    children: [
      {
        path: '',
        name: 'media',
        component: MediaIndex,
        meta: { title: 'Media' }
      }
    ]
  },
  {
    path: '/food-search',
    component: FoodSearch,
    children: [
      {
        path: '',
        name: 'food-search',
        component: FoodSearchIndex,
        meta: { title: 'Food Search' }
      },
      {
        path: 'requests',
        name: 'food-search-requests',
        component: FoodSearchRequestsIndex,
        meta: { title: 'Food Search - Requests'}
      }
    ]
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminIndex,
    meta: { title: 'Admin' },
    children: [
      {
        path: 'users',
        name: 'admin-users',
        component: AdminUsersIndex,
        meta: { title: 'Users' }
      },
      {
        path: 'permissions',
        name: 'admin-permissions',
        component: AdminPermissionsIndex,
        meta: { title: 'Permissions' }
      }
    ]
  },
  {
    path: '/auth',
    component: Auth,
    meta: { noauth: true },
    children: [
      {
        path: '',
        name: 'auth',
        component: AuthIndex,
        meta: { noauth: true }
      },
      /*{
        path: 'forgot',
        name: 'forgot-password',
        component: AuthForgotPassword,
        meta: { noauth: true }
      }*/
    ]
  },
  {
    path: '*',
    redirect: { name: 'dashboard' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
